export const PAPEIS_OBRA_DIALOG_TITLE = "Definir Papel na Obra";
export const PAPEIS_OBRA_NEW_LABEL = "Novo papel";
export const PAPEIS_OBRA_CLOSE_LABEL = "Fechar";
export const PAPEL_SEARCH_PLACEHOLDER = "Buscar papel...";
export const PAPEIS_OBRA_TABLE_LABEL = "Papéis na obra";
export const PAPEIS_OBRA_LOADING_LABEL = "Carregando papéis...";
export const PAPEIS_OBRA_EMPTY_NOUN = "papel";
export const PAPEIS_OBRA_EMPTY_PLURAL = "papéis";
export const EDIT_PAPEL_LABEL = "Editar Papel";
export const INACTIVATE_PAPEL_LABEL = "Inativar Papel";

export const PAPEIS_OBRA_CREATED_MESSAGE = "Papel cadastrado com sucesso.";
export const PAPEIS_OBRA_UPDATED_MESSAGE = "Papel atualizado com sucesso.";
export const PAPEIS_OBRA_INACTIVATED_MESSAGE = "Papel inativado com sucesso.";

export const PAPEIS_OBRA_COLUMNS = [
  { key: "nome", header: "Papel", sortable: true, width: "14rem" },
  // Sem ordenação: comentário de 25/09 da HU 2033.
  { key: "janela", header: "Janela de alocação", sortable: false, width: undefined },
  { key: "ativo", header: "Status", sortable: true, width: "7rem" },
  { key: "acoes", header: "", sortable: false, width: "4rem" },
] as const;
